module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "facture-data row"
  }, [_c('div', {
    staticClass: "col m12 s12 data-column"
  }, [_c('span', {
    staticClass: "title head"
  }, [_vm._v("TYTUŁ FAKTURY/RACHUNKU (NR TRANSZY):")]), _vm._v("\n    " + _vm._s(_vm.token) + "\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col m12 s12 data-column"
  }, [_c('span', {
    staticClass: "title head"
  }, [_vm._v("E-MAIL DO PRZESŁANIA FAKTUR/RACHUNKU:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("mailto:faktury@punkta.pl?subject=Transza nr: " + _vm.token)
    }
  }, [_vm._v("\n      faktury@punkta.pl\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col m12 s12 data-column"
  }, [_c('div', {
    staticClass: "col m12 s12 company-info"
  }, [_c('span', {
    staticClass: "title head"
  }, [_vm._v("DANE PUNKTA:")])]), _vm._v(" "), _c('div', {
    staticClass: "col m6 s12 company-info address"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Punkta sp. z o.o.")]), _vm._v(" "), _c('br'), _vm._v("\n      ul. Aleje Jerozolimskie 146D "), _c('br'), _vm._v("\n      02-305 Warszawa\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col m6 s12 company-info"
  }, [_c('span', {
    staticClass: "title left"
  }, [_vm._v("nr KRS:")]), _vm._v(" 0000488906 "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "title left"
  }, [_vm._v("Regon:")]), _vm._v(" 147010378 "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "title left"
  }, [_vm._v("NIP:")]), _vm._v(" 522-30-11-279\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-387ee636","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoiceDetails.vue
// module id = 372
// module chunks = 0